import type { QueryClient } from '@tanstack/react-query';

import { billingKeys } from '../billing/billing.api';
import { categoryKeys } from '../categories/categories.api';
import { multiUserKeys } from '../multiuser/multiuser.api';
import { transactionKeys } from '../transactions/transactions.api';
import { userKeys } from '../users/users.api';
import { walletKeys } from '../wallets/wallets.api';

export async function invalidateFinanceResources(
  client: QueryClient,
  resources: readonly string[],
): Promise<void> {
  const tasks: Promise<unknown>[] = [];
  if (resources.includes('transactions')) {
    tasks.push(client.invalidateQueries({ queryKey: transactionKeys.all }));
  }
  if (resources.includes('agenda')) {
    tasks.push(client.invalidateQueries({ queryKey: transactionKeys.agenda }));
  }
  if (resources.includes('wallets')) {
    tasks.push(client.invalidateQueries({ queryKey: walletKeys.all }));
  }
  if (resources.includes('categories')) {
    tasks.push(client.invalidateQueries({ queryKey: categoryKeys.all }));
  }
  await Promise.all(tasks);
}

export async function invalidateAccount(client: QueryClient): Promise<void> {
  await Promise.all([
    client.invalidateQueries({ queryKey: userKeys.current }),
    client.invalidateQueries({ queryKey: multiUserKeys.all }),
    client.invalidateQueries({ queryKey: billingKeys.all }),
    client.invalidateQueries({ queryKey: ['finance'] }),
  ]);
}
